'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ToastContainer } from 'react-toastify';
import { GoogleOAuthProvider } from '@react-oauth/google';
import WebPushPermissionPrompt from '../components/WebPushPermissionPrompt';
import env from '../config/env';
import { AppProvider } from '../context/AppContext';
import { AuthProvider } from '../context/AuthContext';
import { SendrealmPushProvider } from '../context/SendrealmPushContext';
export default function Providers(t0) {
  const $ = _c(8);
  const {
    children
  } = t0;
  const [queryClient] = React.useState(_temp);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ReactQueryDevtools initialIsOpen={false} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ToastContainer theme="dark" />;
    t3 = <WebPushPermissionPrompt />;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children) {
    t4 = <AppProvider><GoogleOAuthProvider clientId={env.OAUTH.GOOGLE.CLIENT_ID}><AuthProvider><SendrealmPushProvider>{t2}{t3}{children}</SendrealmPushProvider></AuthProvider></GoogleOAuthProvider></AppProvider>;
    $[3] = children;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== queryClient || $[6] !== t4) {
    t5 = <QueryClientProvider client={queryClient}>{t1}{t4}</QueryClientProvider>;
    $[5] = queryClient;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}
function _temp() {
  return new QueryClient();
}